import script from "./LangToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./LangToggle.vue?vue&type=script&setup=true&lang=js"

import "./LangToggle.vue?vue&type=style&index=0&id=acbcfee8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acbcfee8"]])

export default __exports__